import { FC,  } from 'react'
import { Redirect } from 'react-router-dom'
import PageConnector from '../page-connector'
import { RootState, IAppDispatch } from 'data/store'
import { connect } from 'react-redux'
import { defineTokenAddressBySymbol } from 'helpers'
import * as userAsyncActions from 'data/store/reducers/user/async-actions'
import { useConnection } from 'hooks'

const mapDispatcherToProps = (dispatch: IAppDispatch) => {
  return {
    initialize: (
      provider: any,
      urlChainId?: string,
      urlTokenAddress?: string,
      address?: string | null
    ) => dispatch(userAsyncActions.initialize(
      provider,
      urlChainId,
      urlTokenAddress,
      address
    )),
    reinitialize: (
      address: string,
      urlTokenAddress?: string,
      provider?: any,
    ) => dispatch(userAsyncActions.updateUserData(
      address,
      urlTokenAddress,
      provider
    )),
  }
}

type ReduxType = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatcherToProps>

const mapStateToProps = ({
  user: { chainId, initialized },
}: RootState) => ({
  chainId, initialized
})

const HomePage: FC<ReduxType> = ({
  chainId,
  initialized,
  initialize,
  reinitialize
}) => {

  useConnection(
    initialized,
    initialize,
    reinitialize
  )

  const tokenAddress = defineTokenAddressBySymbol('usdc', chainId)
  const redirect = initialized && chainId ?
    <Redirect to={`/create/${chainId}/${tokenAddress}?amount=0`} />  : null

  return <PageConnector>
    {redirect}
  </PageConnector>
}

export default connect(mapStateToProps, mapDispatcherToProps)(HomePage)